import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/arrears-transaction-table-columns.reducer'

export const selectArrearsTableColumnState = createFeatureSelector<State>('debtAnalysisTransactionAvailableColumns');

export function getAllColumns() {
  return createSelector(
    [selectArrearsTableColumnState],
    (state: State) => {
        return state.allColumns;
    }
  );
}
